import $ from 'jquery';
import Bloodhound from 'vendor/typeahead';
import Mustache from 'mustache';

const searchModule = (() => {
    function typeaheadA11y() {
        $('.search-suggestion-fw').on('typeahead:render', function (evt, suggestion) {
            // console.log('$(\'.site-search__suggestions .tt-suggestion \')')
            setTimeout(function (suggestion) {
                if ($('.predict_search .tt-suggestion').length) {
                    wrapSuggestionsHandler()
                    $('#js-aria-search-result').text($('.predict_search .tt-suggestion').length
                        + " results are available, use up and down arrow keys to navigate.");
                } else {

                    $('#js-aria-search-result').text("No results found");
                }
            }, 2000);
            wrapCarousel();
        });

        $('.search-suggestion-fw').after('<span aria-atomic="true" role="status" aria-live="polite" class="u-screen-reader" id="js-aria-search-result"></span>');
        $('.search-suggestion-fw').on('typeahead:cursorchange', function(ev, suggestion) {
            var index;
            if(suggestion && 'index' in suggestion) index = suggestion.index;
            else index = -1;

            var text = "";
            if(!suggestion){
                $('#js-aria-search-result').text(text);
            }else{
                //Search results are only two type, if not Product, we put them all to SUGGESTION type.
                if(suggestion.termType == 'Product'){
                    if(index == 0) text ="Related Products" + " " + suggestion.brand + " " + suggestion.productName + " " + suggestion.price;
                    else text = suggestion.brand + " " + suggestion.productName + " " + suggestion.price;
                }else {
                    if(index == 0) text ="Suggestions" + " " + suggestion.suggestion;
                }
                $('#js-aria-search-result').text(text);
            }

        });

        function wrapSuggestions($el) {
            $el
                .wrap('<li class="ui-list__item js-search-suggestion-item-wrap"></li>');

            var $suggestionItemWrap = $el.parent();

            $suggestionItemWrap.wrapAll('<ul class="ui-list"></ul>');
        }

        function wrapSuggestionsHandler() {
            var $suggestionItem = $('.js-search-suggestion-item');
            var $simpleSuggestionItem = $('.js-search-simple-suggestion-item');
            wrapSuggestions($suggestionItem);
            wrapSuggestions($simpleSuggestionItem);
        };
    }

    function initTypeahead() {
        typeaheadA11y();

        var products = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.whitespace("productName"),
            queryTokenizer: Bloodhound.tokenizers.whitespace,

            remote: {
              url: '/r/ajax/VisualSearch.jsp?q=%QUERY&fw=true&d='+ $("#search_term_new").data("dep"),
              wildcard: '%QUERY'
            }
        });

        products.initialize();
        const searchProps = (window.rcProps && window.rcProps.search) || {};

        var textSuggestions = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.whitespace("searchTerm"),
            queryTokenizer: Bloodhound.tokenizers.whitespace,

            remote: {
                url : '/r/ajax/TextSuggestions.jsp?q=%QUERY&fw=true&d='+ $("#search_term_new").data("dep"),
                wildcard: '%QUERY',
                filter : function(parsedResponse){
                    return $.map(parsedResponse, function(term){
                        return {"searchTerm" : term};
                    });
                }
            }

        });

        textSuggestions.initialize();
        $('.search-suggestion-fw').typeahead({
                hint: false,
                highlight: true,
                minLength: searchProps.minCharLengthForSearching

            },
            {
                name : 'textSuggestions',
                displayKey: function(obj){
                    return obj.searchTerm.suggestion;
                },
                source: textSuggestions.ttAdapter(),
                templates: {
                    header: '<span role="heading" aria-level="2" class="title h5">Suggestions</span>',
                    suggestion : function(data) {
                        var brandGenderLabel = data.searchTerm.gender ?
                            "<i class=\"u-text-sm u-color-grey\">&nbsp;in " + data.searchTerm.gender.toLowerCase() + "</i>" :
                            "";

                        return '<p style="white-space: normal;"><a href="' + data.searchTerm.suggestionUrl + '">' +
                            data.searchTerm.suggestion + brandGenderLabel + '</a></p>';
                    }
                }
            },
            {
                name: 'recent',
                display: function(obj) {
                    return obj.searchText;
                },
                source: function(query, callback) {
                    callback(searchProps.recentSearchJson);
                },
                templates: {
                    suggestion: function(data) {
                        return Mustache.render(searchProps.recentSearchTemplate, data);
                    }
                },
                limit: searchProps.recentSearchLimit
            },
            {
                name: 'products',
                displayKey: 'productName',
                source: products.ttAdapter(),
                templates: {
                    header: '<span role="heading" aria-level="2" class="title h5">Related Products</span>',
                    suggestion: function(data){
                        return Mustache.render(searchProps.productSuggestionTemplate, data);
                    }

                },
            }
        ).on('typeahead:select', function (event, suggestion) {
                if ('href' in suggestion) { // Recent search
                    window.location.href = suggestion.href;
                }
            }
        ).on('typeahead:selected', function(obj, datum, name){
            if(name == 'textSuggestions'){
                window.location.href = datum.searchTerm.suggestionUrl;
            }
            if(name == 'products'){
                window.location.href = datum.productURL;
            }
        }
        ).on('click', function(){
            if (typeof logEngagement === 'function'){
                logEngagement(window.location.href, 'Search Box', 'Click');
            }
        });

        $(".tt-menu").addClass("predict_search").css({
            "left" : "0",
            "position" : "absolute",
            "z-index" : "",
            "right" : ""
        });
        $(".tt-dataset-textSuggestions").addClass("predict_suggest");
        $(".tt-dataset-recent").addClass("predict_recent");
        $(".tt-dataset-products").addClass("predict_related");

        function getSearchURL(searchTerm){
            var dParam = $("#search_term_new").data("dep");
            var data;
            if(dParam){
                data = $.param({
                    search : searchTerm,
                    d : dParam
                });
            }else{
                data = $.param({
                    search : searchTerm
                });
            }

            return '/fw/content/s/url?' + data;
        }

        $(".no-result-search").click(function(){
            var searchTerm = $("#no-search-input").val();
            if(!searchTerm) return;
            var url = getSearchURL(searchTerm);
            window.location.href = url;
        });

        $("#no-search-input").keypress(function(event){
            if(event.which == 13){
                var searchTerm = $(this).val();
                if(!searchTerm) return;
                var url = getSearchURL(searchTerm);
                window.location.href = url;
            }
        });
    }

    function wrapCarousel() {
        const $suggestionCarousel = $('.js-search-suggestion')
        if($suggestionCarousel && $suggestionCarousel.parent().hasClass('product'))
        return;
        $suggestionCarousel.wrap('<div class="product grid__col"></div>')
        const $suggestionItemWrap = $suggestionCarousel.parent();
        $suggestionItemWrap.wrapAll('<div class="grid n-block-grid--3 u-margin-t--lg u-padding-b--sm"></div>'); 
    }

    return {
        init: function() {
            initTypeahead();
        }
    };
})();

export default searchModule;



// WEBPACK FOOTER //
// ./src/scripts/modules/search.js